<template>
  <div class="go-card-view mt-4">
    <div class="row g-4">
      <div class="col-lg-4 col-md-12">
        <div class="card border-0 shadow-sm go-card-panel h-100">
          <div class="card-body">
            <div class="section-heading mb-3">
              <h6 class="mb-1">Acciones de GO Card</h6>
              <p class="text-sm text-muted mb-0">Administra el saldo, el estado y la eliminación de la tarjeta desde este bloque.</p>
            </div>

            <div class="action-box mb-4">
              <label class="form-label fw-bold">Agregar saldo</label>
              <p class="text-xs text-muted mb-2">Ingresa el monto que deseas sumar al saldo actual.</p>
              <p v-if="!goCard" class="text-sm text-warning fw-bold mb-2">El cliente aún no ha solicitado su GO Card.</p>
              <div class="row g-2 align-items-end">
                <div class="col-md-7">
                  <input type="number" class="form-control" v-model="balance" placeholder="Monto a agregar" :disabled="!goCard">
                </div>
                <div class="col-md-5 d-grid">
                  <button class="btn btn-success mb-0" @click="addBalance" :disabled="!goCard">Agregar saldo</button>
                </div>
              </div>
            </div>

            <div class="action-box mb-4">
              <label class="form-label fw-bold">Actualizar estado</label>
              <p class="text-xs text-muted mb-2">Cambia el estado de aprobación de la GO Card.</p>
              <select class="form-control" @change="updateStatus" v-model="status_selected" :disabled="!goCard">
                <option value="">Selecciona una opción</option>
                <option value="true">Aprobada</option>
                <option value="false">No aprobada</option>
              </select>
            </div>

            <div class="danger-box">
              <label class="form-label fw-bold text-danger">Acción irreversible</label>
              <p class="text-xs text-muted mb-2">Eliminá la GO Card del usuario si ya no debe existir.</p>
              <button class="btn btn-danger w-100 mb-0" @click="remove" :disabled="!goCard">Eliminar GO Card</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-8 col-md-12">
        <div class="card border-0 shadow-sm go-card-panel h-100">
          <div class="card-body">
            <div class="section-heading mb-3">
              <h6 class="mb-1">Resumen de GO Card</h6>
              <p class="text-sm text-muted mb-0">Información actual de la tarjeta asociada al usuario.</p>
            </div>

            <div v-if="goCard" class="summary-grid">
              <div class="summary-item highlight">
                <span class="summary-label">Saldo actual</span>
                <strong class="summary-value">{{ goCard.balance }}</strong>
              </div>

              <div class="summary-item">
                <span class="summary-label">Estado</span>
                <strong class="summary-value" :class="!goCard.status ? 'text-danger' : 'text-success'">
                  {{ !goCard.status ? 'No aprobada' : 'Aprobada' }}
                </strong>
              </div>

              <div class="summary-item">
                <span class="summary-label">Nombre</span>
                <strong class="summary-value">{{ goCard.name }}</strong>
              </div>

              <div class="summary-item">
                <span class="summary-label">Identificación</span>
                <strong class="summary-value">{{ goCard.identification }}</strong>
              </div>

              <div class="summary-item">
                <span class="summary-label">Dirección</span>
                <strong class="summary-value">{{ goCard.address }}</strong>
              </div>

              <div class="summary-item">
                <span class="summary-label">Ciudad</span>
                <strong class="summary-value">{{ goCard.city }}</strong>
              </div>

              <div class="summary-item">
                <span class="summary-label">País</span>
                <strong class="summary-value">{{ goCard.country }}</strong>
              </div>

              <div class="summary-item">
                <span class="summary-label">Shipping</span>
                <strong class="summary-value">{{ goCard.shipping }}</strong>
              </div>

              <div class="summary-item full-width">
                <span class="summary-label">Fecha de creación</span>
                <strong class="summary-value">{{ goCard.created_at }}</strong>
              </div>
            </div>

            <div v-else class="empty-state">
              <h6 class="mb-1">No hay información de GO Card</h6>
              <p class="text-sm text-muted mb-0">Aún no se encontró una tarjeta asociada a este usuario.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";

export default {
  name: "Notes",
  data: () => ({
    user_id: null,
    goCard: null,
    balance: 0,
    status_selected: ''
  }),
  mounted() {
    this.user_id = this.$route.query.id
    this.getGoCard()
  },
  methods:{
    async getGoCard(){
      const {data} = await get(`go-card/by-user?id=${this.user_id}`)
      this.goCard = data
    },

    async addBalance(){
      if(this.balance !== 0){
        await post('go-card/add-balance',{id: this.user_id, balance: this.balance})
        await this.getGoCard()
        this.balance = 0
        this.$swal({
          html: 'Procesado con éxito',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
    async remove(){
      await post('go-card/remove',{id: this.user_id})
      await this.getGoCard()
      this.$swal({
        html: 'Procesado con éxito',
        icon: 'success',
        timer: 2000,
        showCancelButton: false,
        showConfirmButton: false,
      });
    },
    async updateStatus(){
      if(this.status_selected !== ''){
        await post('go-card/update-status',{id: this.user_id, status: this.status_selected})
        await this.getGoCard()
        this.$swal({
          html: 'Procesado con éxito',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    }
  }
}
</script>

<style scoped>
.go-card-panel {
  border-radius: 1rem;
}

.section-heading h6 {
  font-size: 1rem;
  font-weight: 700;
}

.action-box,
.danger-box,
.summary-item,
.empty-state {
  background: #f8f9fa;
  border-radius: 0.85rem;
  padding: 1rem;
}

.danger-box {
  border: 1px solid rgba(234, 6, 6, 0.15);
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.summary-item.highlight {
  background: linear-gradient(135deg, rgba(130, 214, 22, 0.12), rgba(130, 214, 22, 0.04));
}

.summary-item.full-width {
  grid-column: 1 / -1;
}

.summary-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8392ab;
  font-weight: 700;
}

.summary-value {
  color: #344767;
  word-break: break-word;
}

.empty-state {
  text-align: center;
}

@media (max-width: 991px) {
  .summary-grid {
    grid-template-columns: 1fr;
  }

  .summary-item.full-width {
    grid-column: auto;
  }
}
</style>
